/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { Widget } from 'features/types'
import { ImageWidget as ImageWidgetType } from 'schemas/ImageWidgetSchema'
import { useDashboardWidgetSetting } from '../../../hooks/useDashboardState'
import { useThirdPartySettings } from '../../../hooks/usePageConfig'
import getImageScalingStyle from '../../../utils/imageWidgetUtil'
import ImageUrlPrefix from '../../../enums/ImageUrlPrefix'
import StyledImageWidget from './index.css'
import WaveLoading from '../../share/WaveLoading'

const ImageWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<ImageWidgetType>(widgetId)
  const thirdPartySettings = useThirdPartySettings()

  if (!widgetSetting) return <WaveLoading />
  if (!thirdPartySettings) return <WaveLoading />

  const { url, scaling, alignment } = widgetSetting
  if (typeof url !== 'string') {
    return <></>
  }

  let fullUrl = url
  if (url.length > 1 && url.charAt(0) === ImageUrlPrefix.TWITTER) {
    fullUrl = `${thirdPartySettings.twitterAvatarsIo}${url.slice(1)}`
  }
  if (url.length > 1 && url.charAt(0) === ImageUrlPrefix.S3) {
    fullUrl = `${thirdPartySettings.s3ImagePrepend}${url.slice(1)}`
  }

  return (
    <StyledImageWidget
      url={fullUrl}
      scaling={getImageScalingStyle(scaling!)}
      alignment={alignment}
    />
  )
}
export default ImageWidget
